import {action} from "mobx";
import React from "react";
import {Spinner, Text} from "react-vcomponents";
import {O, RunInAction, RunInAction_Set} from "web-vcore";
import {store} from "../../../../../Store/index.js";
import {GetOpenMapID} from "../../../../../Store/main/maps.js";
import {GetMapState} from "../../../../../Store/main/maps/$mapState.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";
import {MapTool, Tool, ToolData, ToolInterceptSubresult} from "./@Tool.js";
import {MapDragInfo} from "./Helpers/DragHelper.js";
import {Rect, Vec2, Vec3} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {ResolveObjPosInWorld} from "../../../../../Server/DB/mapObjects/$mapObject.js";
import {GetMapObjects} from "../../../../../Server/DB/mapObjects.js";
import {MapSurface_current} from "../../MapSurface.js";
import {observer_mgl} from "mobx-graphlink";
import {ignore} from "mobx-sync";

export class ToolState_Select {
	@O @ignore accessor currentDrag: MapDragInfo|n;
	@action EndCurrentDrag() {
		if (this.currentDrag == null) return;
		this.currentDrag = null;
	}
}

export class Tool_Select extends Tool {
	toolType = MapTool.select;
	get ToolState() { return store.main.maps.tools.toolStates.select; }

	RenderInToolbox = observer_mgl(({data}: {data: ToolData.RenderInToolbox})=>{
		const state = this.ToolState;
		return (
			<>
			</>
		);
	});
	RenderInSceneOverlay = observer_mgl((props: {data: ToolData.RenderInSceneOverlay})=>{
		const state = this.ToolState;
		const drag = state.currentDrag;
		const mapControls_DOM = MapSurface_current?.mapControls?.DOM;
		if (drag == null || mapControls_DOM == null) return null;

		const currentPos = drag?.currentPos_world ?? drag?.startPos_world ?? Vec3.zero;
		const currentPos_mouse = mapControls_DOM.WorldPosToClientPos(currentPos.ToVec2());
		const min = new Vec2(Math.min(drag.startPos_mouse.x, currentPos_mouse.x), Math.min(drag.startPos_mouse.y, currentPos_mouse.y));
		const max = new Vec2(Math.max(drag.startPos_mouse.x, currentPos_mouse.x), Math.max(drag.startPos_mouse.y, currentPos_mouse.y));
		return <div style={{
			position: "fixed",
			border: "1px solid white",
			pointerEvents: "none",
			zIndex: 100,
			left: `${min.x}px`,
			top: `${min.y}px`,
			width: `${max.x - min.x}px`,
			height: `${max.y - min.y}px`,
		}}/>;
	});

	Document_OnKeyDown(data: ToolData.Document_OnKeyDown): ToolInterceptSubresult | void {
		if (data.event.key == "Escape") {
			this.ToolState.EndCurrentDrag();
			return {absorb: true};
		}
	}

	Scene_OnPointerDown(data: ToolData.Scene_OnPointerClick) {
		const {event, mousePos, mousePos_world, controls} = data;
		if (event.button != 0) return;

		const state = this.ToolState;
		if (state.currentDrag == null) {
			RunInAction("Select.Scene_OnPointerDown", ()=>{
				state.currentDrag = new MapDragInfo({
					button: event.button,
					startPos_mouse: mousePos,
					startPos_world: mousePos_world,
					currentPos_mouse: mousePos,
					currentPos_world: mousePos_world,
				});
			});
		}
	}

	Document_OnPointerMove(data: ToolData.Document_OnPointerMove) {
		const {event, mousePos, mousePos_world, controls} = data;
		const state = this.ToolState;
		const drag = state.currentDrag;
		if (drag) {
			RunInAction("Select.Document_OnPointerMove", ()=>{
				drag.currentPos_mouse = mousePos;
				drag.currentPos_world = mousePos_world;
			});
		}
	}

	Document_OnPointerUp(data: ToolData.Document_OnPointerUp) {
		const {event, mousePos, mousePos_world, controls} = data;
		const state = this.ToolState;
		const drag = state.currentDrag;
		if (drag?.button == event.button) {
			RunInAction("Select.Document_OnPointerUp", ()=>{
				const min = new Vec2(Math.min(drag.startPos_world.x, mousePos_world.x), Math.min(drag.startPos_world.y, mousePos_world.y));
				const max = new Vec2(Math.max(drag.startPos_world.x, mousePos_world.x), Math.max(drag.startPos_world.y, mousePos_world.y));
				const rect = new Rect(min, max.Minus(min), true);

				const mapID = GetOpenMapID.CatchBail(null);
				if (!mapID) return;
				const mapState = GetMapState.CatchBail(null, mapID);
				if (mapState == null) return;
				const mapObjects = GetMapObjects.CatchBail(null, mapID);
				if (!mapObjects) return;

				const objectsInRect = mapObjects.filter(a=>{
					const objPosInWorld = ResolveObjPosInWorld(a);
					return rect.Intersects(new Rect(objPosInWorld.ToVec2(), Vec2.zero, true));
				}).map(a=>a.id);
				mapState.selectedObjects = objectsInRect;
				mapState.activeObject = objectsInRect[0];
			});

			this.ToolState.EndCurrentDrag();
		}
	}
}